import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OiamService } from '../services/apiservices/oiam.service';
import { switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';

export const requestInterceptor: HttpInterceptorFn = (req, next) => {
    const oiamService = inject(OiamService);

    const protectedUrl = ['/pd/', '/ud/'].some((it) => req.url.includes(it));

    if (!protectedUrl) {
        return next(req);
    }

    return oiamService.validToken.pipe(
        switchMap((jwt) => {
            const clonedRequest = req.clone({
                withCredentials: true,
                headers: req.headers
                    .append('authorization', `Bearer ${jwt}`)
                    .append('x-api-key', environment.oiam.clientId)
            });
            return next(clonedRequest);
        })
    );
};
